var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { TSS_BLUE_1, scrollGuard, stylePropType } from 'tss-core-lib-common';

var styles = void 0;

var Menu = function (_Component) {
  _inherits(Menu, _Component);

  function Menu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Menu.__proto__ || Object.getPrototypeOf(Menu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this.setScrollRef = function (ref) {
      _this.scrollRef = ref;
    }, _this.handleClick = function (event) {
      return _this.props.onChange(event.target.getAttribute('data-value'), event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Menu, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        if (_this2.props.currentValue !== null && _this2.scrollRef) {
          var scrollRef = _this2.scrollRef;
          var currentValueElement = [].concat(_toConsumableArray(scrollRef.getElementsByClassName('menu__menu-item'))).find(function (e) {
            return e.getAttribute('data-value') === _this2.props.currentValue.toString();
          });
          if (currentValueElement) {
            _this2.scrollRef.scrollTop = currentValueElement.offsetTop;
          }
        }
      }, 10);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      if (this.props.items.length === 0) {
        return null;
      }

      return React.createElement(
        'div',
        { className: css(styles.container), ref: this.setScrollRef, onWheel: scrollGuard },
        React.createElement(
          'ul',
          { className: css(styles.list) },
          this.props.items.map(function (_ref2) {
            var value = _ref2.value,
                label = _ref2.label;
            return React.createElement(
              'li',
              { key: value, 'data-value': value, className: 'menu__menu-item ' + css(styles.item) },
              React.createElement(
                'div',
                {
                  className: css(styles.itemButton, _this3.props.itemStyle, _this3.props.currentValue === value && styles.itemButtonCurrent),
                  'data-value': value,
                  onClick: _this3.handleClick,
                  role: 'button',
                  tabIndex: 0,
                  style: { textAlign: _this3.props.alignContent }
                },
                label
              )
            );
          })
        )
      );
    }
  }]);

  return Menu;
}(Component);

Menu.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  currentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  alignContent: PropTypes.string,
  itemStyle: stylePropType,
  onChange: PropTypes.func.isRequired
};
Menu.defaultProps = {
  currentValue: null,
  alignContent: 'left',
  itemStyle: null
};


styles = StyleSheet.create({
  container: {
    border: '2px solid ' + TSS_BLUE_1(),
    maxHeight: '20rem',
    overflow: 'auto',
    outline: 0,
    backgroundColor: 'white',
    boxShadow: '0 2px 10px 2px rgba(0,0,0,0.15)'
  },

  list: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    outline: 0
  },

  item: {
    margin: 0,
    backgroundColor: 'white',
    outline: 0,

    ':nth-of-type(1n) + .menu__menu-item': {
      borderTop: '1px solid ' + TSS_BLUE_1()
    },

    ':hover': {
      backgroundColor: TSS_BLUE_1(0.5)
    }
  },

  itemButton: {
    outline: 0,
    padding: '1rem 1.8rem 1rem 1rem',
    fontSize: '1.4rem',
    cursor: 'pointer'
  },

  itemButtonCurrent: {
    backgroundColor: TSS_BLUE_1(0.4)
  }
});

export default Menu;